import React, { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { getChannel } from 'utils/getChannel';

const Layout = ({ children }: { children?: React.ReactNode }) => {
  const channelName = getChannel().key;
  const theme = useTheme();

  useEffect(() => {
    const themeClassName = theme.id ? theme.id.split('-theme')[0] : undefined;
    document.body.classList.add(channelName);

    if (themeClassName) document.body.classList.add(themeClassName);

    return () => {
      document.body.classList.remove(channelName);
      if (themeClassName) document.body.classList.remove(themeClassName);
    };
  }, [channelName, theme?.id]);

  return <>{children}</>;
};

export default Layout;
